import { AfterViewInit, Component, Input, OnChanges, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from 'src/app/core/service/event.service';
import { AuthenticationService } from '../../../core/service/auth.service';
import { MenuItem } from '../models/menu.model';
import { changeBodyAttribute, findAllParent, findMenuItem } from '../helper/utils';
import feather from "feather-icons";
import { UtilsService } from 'src/app/core/service/utils.service';
import { DataService } from 'src/app/core/service/data.service';
import { LEFT_SIDEBAR_TYPE_CONDENSED, LEFT_SIDEBAR_TYPE_DEFAULT } from '../config/layout.model';

@Component({
  selector: 'app-left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss']
})
export class LeftSidebarComponent implements OnInit, AfterViewInit {
  @Input() layoutType: string = '';
  @Input() navClasses: string | undefined;
  @Input() includeUserProfile: boolean = false;
  hasTwoToneIcons: boolean = false;
  isInitialized: boolean = false;

  leftSidebarClass = 'sidebar-enable';
  activeMenuItems: string[] = [];

  loggedInUser: any = {};


  menuItems: MenuItem[] = [];

  accountPhoto: any = 'null';

  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private eventService: EventService,
    protected utilSrv: UtilsService,
    protected dataSrv: DataService) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => {
          this._activateMenu(); //actiavtes menu
          this.hideMenu(); //hides leftbar on change of route
        }, 50);
      }
    });


  }

  ngOnInit(): void {
    this.initMenu();
    this.loggedInUser = this.authService.currentUser;

    this.eventService.subscribe('toggleTwoToneIcons', (enable) => {
      this.hasTwoToneIcons = enable;
      if (this.hasTwoToneIcons) {
        document.body.setAttribute("data-sidebar-icon", "twotones");
      }
      else {
        document.body.removeAttribute("data-sidebar-icon");
      }
    });
    this.accountPhoto = this.loggedInUser?.urlPhoto;
    if (!this.accountPhoto) this.accountPhoto = '../../../../assets/images/user-avatar.jpg';

    this.eventService.subscribe('toggleProjectMenu', (data) => {
      if (data.projectId) {
        this.menuItems = this.dataSrv.getProjectMenu(data.projectId, data.projectName.substring(0, 17));
      } else {
        this.initMenu();
      }
    });

    //setTimeout(() => {
    //  this.eventService.broadcast('toggleProjectMenu', { projectId: 1 });
    //}, 2000)
  }

  ngOnChanges(): void {
    if (this.includeUserProfile) {
      document.body.setAttribute("data-sidebar-showuser", "true");
    }
    else {
      document.body.removeAttribute("data-sidebar-showuser");
    }
  }

  /**
   * On view init - activating menuitems
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this._activateMenu();
    });
    feather.replace();
  }

  /**
   * initialize menuitems
   */
  initMenu(): void {
    this.menuItems = this.dataSrv.getMenu();
  }

  /**
   * activates menu
   */
  _activateMenu(): void {
    const div = document.getElementById('side-menu');
    let matchingMenuItem = null;

    if (div) {
      let items: any = div.getElementsByClassName('side-nav-link-ref');
      for (let i = 0; i < items.length; ++i) {
        if (window.location.pathname === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }

      if (matchingMenuItem) {
        const mid = matchingMenuItem.getAttribute('data-menu-key');
        const activeMt = findMenuItem(this.menuItems, mid);
        if (activeMt) {

          const matchingObjs = [activeMt['key'], ...findAllParent(this.menuItems, activeMt)];

          this.activeMenuItems = matchingObjs;

          this.menuItems.forEach((menu: MenuItem) => {
            menu.collapsed = !matchingObjs.includes(menu.key!);
          });
        }
      }
    }
  }

  /**
   * toggles open menu
   * @param menuItem clicked menuitem
   * @param collapse collpase instance
   */
  toggleMenuItem(menuItem: MenuItem, collapse: NgbCollapse): void {
    collapse.toggle();
    let openMenuItems: string[];
    if (!menuItem.collapsed) {
      openMenuItems = ([menuItem['key'], ...findAllParent(this.menuItems, menuItem)]);
      this.menuItems.forEach((menu: MenuItem) => {
        if (!openMenuItems.includes(menu.key!)) {
          menu.collapsed = true;
        }
      })
    }

  }


  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasSubmenu(menu: MenuItem): boolean {
    return menu.children ? true : false;
  }


  /**
   * Hides the menubar
   */
  hideMenu() {
    document.body.classList.remove('sidebar-enable');
  }

  logout() {
    this.router.navigate(['/auth/logout'])
  }

  isSmallScreen() {
    if (window.innerWidth < 600) {
      return true
    } else {
      return false;
    }
  }

  isEnable() {
    if (document.body.classList.contains('sidebar-enable')) {
      return true;
    } else {
      return false;
    }
  }
  profileIcon() {    
      this.router.navigate([`profile`]);    
  }
  changeSidebarWidth(): void {
    if (document.body.hasAttribute('data-sidebar-size') && document.body.getAttribute('data-sidebar-size') === "condensed") {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_DEFAULT);
      changeBodyAttribute("data-sidebar-size", LEFT_SIDEBAR_TYPE_DEFAULT);
    }
    else {
      this.eventService.broadcast('changeLeftSidebarType', LEFT_SIDEBAR_TYPE_CONDENSED);
      changeBodyAttribute("data-sidebar-size", LEFT_SIDEBAR_TYPE_CONDENSED);
    }
  }
}
